import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group" }
const _hoisted_3 = { class: "flex alignC" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_5 = { class: "w-500 title" }
const _hoisted_6 = { class: "items" }
const _hoisted_7 = { class: "parent" }
const _hoisted_8 = {
  key: 0,
  class: "child"
}
const _hoisted_9 = { class: "children" }
const _hoisted_10 = {
  key: 0,
  class: "grandson"
}
const _hoisted_11 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center","padding":"20px 0"}
}
const _hoisted_12 = { class: "c-ff" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _directive_loading = _resolveDirective("loading")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.form,
      "label-width": "150px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "角色名称",
          prop: "role_name",
          rules: [{ required: true, message: '请输入角色名称' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              style: {"width":"350px"},
              modelValue: _ctx.form.role_name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.role_name = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList([_ctx.pcList, _ctx.h5List], (item, index) => {
      return (_openBlock(), _createBlock("div", { key: index }, [
        _createVNode("p", _hoisted_5, _toDisplayString(index == 0 ? "PC端权限" : "手机端权限"), 1),
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(item, (route, indexs) => {
            return (_openBlock(), _createBlock("div", {
              class: "menu",
              key: indexs
            }, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_el_checkbox, {
                  modelValue: route.type,
                  "onUpdate:modelValue": ($event: any) => (route.type = $event),
                  "true-label": 1,
                  "false-label": 0,
                  onClick: ($event: any) => (_ctx.selectAllChildren(route.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(route.name), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onClick"])
              ]),
              (route.children.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(route.children, (child) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "item",
                        key: child.id
                      }, [
                        _createVNode("div", _hoisted_9, [
                          _createVNode(_component_el_checkbox, {
                            modelValue: child.type,
                            "onUpdate:modelValue": ($event: any) => (child.type = $event),
                            "true-label": 1,
                            "false-label": 0,
                            onClick: ($event: any) => (_ctx.selectAllGrandson(child.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(child.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "onClick"])
                        ]),
                        (child.grandson.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_10, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(child.grandson, (grandson) => {
                                return (_openBlock(), _createBlock(_component_el_checkbox, {
                                  key: grandson.id,
                                  modelValue: grandson.type,
                                  "onUpdate:modelValue": ($event: any) => (grandson.type = $event),
                                  "true-label": 1,
                                  "false-label": 0
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(grandson.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    }), 128)),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$route.query.id ? "保存" : "确定"), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ])
  ], 512)), [
    [_directive_loading, _ctx.loading]
  ])
}